import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { createFunctionResult, FUNCTION_RESULT_STATUS, FunctionResult, IFieldUpdate, IObjectKey, isObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, ISubscription } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService extends CommonService<ISubscription, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_INSERT;
  public override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_MERGE;
  public override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_UPDATE;
  public updateByFieldFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_UPDATEBYFIELD;
  public suspendFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_SUSPEND;
  public activateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_ACTIVATE;
  public cancelFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_CANCEL;
  public override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_GETALL;
  public override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_GET;
  public override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_GETKEYS;
  public getByCustomerFunctionName: FUNCTION_NAME = FUNCTION_NAME.PRODUCTS_SUBSCRIPTION_GETBYCUSTOMER;

  constructor(functions: Functions) {
    super(functions);
  }

  /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async updateByField(values: IFieldUpdate): Promise<FunctionResult<ISubscription>> {
    this.isLoading(true);
    console.debug("Calling Function", this.updateByFieldFunctionName.toString());

    return new Promise<FunctionResult<ISubscription>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<ISubscription>>(
        this.functions,
        this.updateByFieldFunctionName.toString()
      );
      callable(values)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async suspend(key: IObjectKey | string): Promise<FunctionResult<ISubscription>> {
    this.isLoading(true);
    console.debug("Calling Function", this.suspendFunctionName.toString());

    return new Promise<FunctionResult<ISubscription>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<ISubscription>>(
        this.functions,
        this.suspendFunctionName.toString()
      );
      callable(key)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async activate(key: IObjectKey | string): Promise<FunctionResult<ISubscription>> {
    this.isLoading(true);
    console.debug("Calling Function", this.activateFunctionName.toString());

    return new Promise<FunctionResult<ISubscription>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<ISubscription>>(
        this.functions,
        this.activateFunctionName.toString()
      );
      callable(key)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  /**
   * Update object of type T
   * Allows for optional refreshing of the service's objects collection (Default: false)
   * @param { T } obj
   * @param { boolean} refresh
   * @return { Promise<T> }
   */
  public async cancel(key: IObjectKey | string): Promise<FunctionResult<ISubscription>> {
    this.isLoading(true);
    console.debug("Calling Function", this.cancelFunctionName.toString());

    return new Promise<FunctionResult<ISubscription>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<ISubscription>>(
        this.functions,
        this.cancelFunctionName.toString()
      );
      callable(key)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  public async getByCustomer(key: IObjectKey | string): Promise<FunctionResult<ISubscription[]>> {
    this.isLoading(true);

  let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<ISubscription[]>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<ISubscription[]>>(
        this.functions,
        this.getByCustomerFunctionName.toString()
      );
      callable(myId)
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<ISubscription[] | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this.isLoading(false);
        });
    });
  }
}
